import { Factory } from './Factory'
import Menu from '../EditorComponents/Video/Menu'
export class VideoFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('video'),
      slug: 'editor-video',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      contentClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      name: 'Video',
    }
  }

  properties() {
    return {
      content: [
        {key: 'video-source', component: 'ContentVideoSource'},
        {key: 'text-content', component: 'ContentText', text: 'source url', property: 'srcLink'},
        {key: 'has-autoplay', component: 'ContentToggle', text: 'autoplay', property: 'autoplay'},
      ],
      styles: [
        {key: 'text-alignment', component: 'TextAlignmentProperty', class:'containerClasses', except: ['JUSTIFY']},
        {key: 'border', component: 'BorderProperty'},
        {key: 'rounded', component: 'RoundedProperty'},
        {key: 'shadow', component: 'ShadowProperty'},
        {key: 'margin', component: 'MarginProperty', class:'containerClasses'},
        {key: 'video-width', component: 'CustomWidthProperty', styles: 'containerStyles', value: '460'},
        {key: 'video-height', component:'CustomHeightProperty', styles: 'containerStyles', value: '315'},
        {key: 'color', component: 'TextColorProperty', text:'theme color', property: 'colorStyle'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
